import { Button } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { BsArrowRight } from 'react-icons/bs';

const MotionButton = motion(Button);

interface IColorSchemaButtonGradient {
  main: string;
  secondaryInitial: string;
  secondaryFinal: string;
}

interface IOwnProps {
  onClick(): void;
  children: string;
  colorSchema: IColorSchemaButtonGradient;
}

const NavigationButtonSPDetailMobilePage: React.FC<IOwnProps> = ({ children, onClick, colorSchema }) => {
  return (
    <MotionButton
      size="sm"
      py={5}
      w="full"
      borderRadius="md"
      bgGradient={`linear(to-r, ${colorSchema.main}, ${colorSchema.secondaryInitial})`}
      color="white"
      fontWeight="bold"
      rightIcon={<BsArrowRight />}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      boxShadow="0 4px 14px rgba(0, 0, 0, 0.15)"
      _active={{
        bgGradient: `linear(to-r, ${colorSchema.secondaryFinal}, ${colorSchema.main})`,
      }}
      _hover="none"
      onClick={onClick}
    >
      {children}
    </MotionButton>
  );
};

export default NavigationButtonSPDetailMobilePage;
